import React from "react"

function IconMediaPlay({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="media-play"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-media-play"
      {...props}
    >
      <path
        d="M6.436 6.545v11.11c0 1.34 1.453 2.18 2.614 1.509l9.62-5.555c1.163-.673 1.163-2.35 0-3.02L9.05 5.035a1.742 1.742 0 0 0-2.614 1.51zm1.96-.376 9.62 5.554c.29.167.29.585 0 .753l-9.62 5.554a.434.434 0 0 1-.65-.376V6.544c0-.334.36-.542.65-.375z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMediaPlay
